var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrowsh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#597936",
    d: "M298 281v-21.7h-22v-22H120V216H98V61h11V17.4H65.5v44h11V105h-44V61.2h11V17.4H-.2v43.8h11v198h21.8V281h22v22H320v-22h-22zM10.7 50.3v-22h22v22h-22zM76.4 149H32.6v-22h43.8v22zm0-120.5h22v22h-22v-22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5d432e",
    d: "M253.4 194v-16.2H158v-58.3h62V148h-15v-13.6h-32.2V163h80.6v-55.2h-22v-22H143v22h-22V194h22v22h132.4v-22z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#44602d",
    d: "M121 281v-22H55v-21H11v21h22v22h22v22h265v-22z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4a2e18",
    d: "M143 194h132v22H143zm-22-86h22v86h-22zm132 43.2V131h-17v17h-16v15h33z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowsh);
export default __webpack_public_path__ + "static/media/browsh.ca1703ea581a1eb4560714e7efa6c235.svg";
export { ForwardRef as ReactComponent };